var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"drop-zone",class:{active: _vm.isHTML5UploadSupported}},[_c('i',{staticClass:"fa fa-upload"}),_c('a',{domProps:{"textContent":_vm._s(_vm.$t('drop-here'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }